import { render, staticRenderFns } from "./2.vue?vue&type=template&id=b5917602&scoped=true&"
import script from "./2.vue?vue&type=script&lang=js&"
export * from "./2.vue?vue&type=script&lang=js&"
import style0 from "./2.vue?vue&type=style&index=0&id=b5917602&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5917602",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VFlex,VIcon,VLayout})
